import React from "react";
import { useNavigate } from "react-router-dom";
import { EMutualFundFlow } from "../MutualFund";
const EmandateInfoPage = (props) => {
    const navigate = useNavigate();
    return (React.createElement("div", { className: "enach-info-page" },
        React.createElement("h2", { className: "DMSansMedium_20_500 txt_black-seven taCenter" }, "Your request for new mandate is in process in new tab"),
        React.createElement("p", { className: "DMSanM_14_500 txt_warm-grey-eight" }, "You will receive confirmation on new mandate from exchange on your registered email id."),
        React.createElement("div", { className: "info-block" },
            React.createElement("div", { className: "info-icon" },
                React.createElement("i", { className: "edel-icon-mail-sent" },
                    React.createElement("i", { className: "path1" }),
                    React.createElement("i", { className: "path2" }))),
            React.createElement("p", { className: "DMSanN_14_400 txt_blackOne1" },
                "Complete your process on",
                React.createElement("br", null),
                " the new tab")),
        React.createElement("div", { className: "info-block" },
            React.createElement("div", { className: "info-icon" },
                React.createElement("i", { className: "edel-icon-days-calender" },
                    React.createElement("i", { className: "path1" }),
                    React.createElement("i", { className: "path2" }))),
            React.createElement("p", { className: "DMSanN_14_400 txt_blackOne1" },
                "eMandate typically takes",
                React.createElement("br", null),
                " 2-3 days to be approved")),
        React.createElement("div", { className: "info-block" },
            React.createElement("div", { className: "info-icon" },
                React.createElement("i", { className: "edel-icon-circle-profile" },
                    React.createElement("i", { className: "path1" }),
                    React.createElement("i", { className: "path2" }))),
            React.createElement("p", { className: "DMSanN_14_400 txt_blackOne1 mb-80" },
                "Status of the mandate can be",
                React.createElement("br", null),
                " checked in the",
                React.createElement("a", { className: "txt-midnight-blue", onClick: () => { navigate("/profile"); } },
                    " ",
                    React.createElement("u", null, "Profile")),
                " section")),
        React.createElement("div", { className: "Roboto_16_400 txt-midnight-blue", onClick: () => {
                props.setShow(EMutualFundFlow.PURCHASE);
            } },
            React.createElement("i", { className: "edel-icon-arrow-left" }),
            " Back to your SIP Order")));
};
export default EmandateInfoPage;
